import { type CSSProperties } from 'react';

interface LogoProps {
  size?: number;
  style?: CSSProperties;
  className?: string;
}

export function Logo({ size = 19, style, className }: LogoProps) {
  return (
    <span className={`pp-logo ${className ?? ''}`} style={{ fontSize: size, ...style }}>
      <span className="pp-logo-mark" style={{ width: size * 1.5, height: size * 1.5 }} />
      <span>Platterplan</span>
    </span>
  );
}
